import { api } from '@/utils/client';

const state = {
	index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
}

// actions
const actions = {
	async fetchPaymentDocuments(context, page) {
		try {
			let response = null;
			if (page.type) response = await api.get('/teams/' + context.rootState.teamId + '/payment-documents',  {params:page});
			else response = await api.get('/teams/' + context.rootState.teamId + '/payment-documents',  {params:page});
			context.commit('fetchPaymentDocuments', response.data);
			return response;
		} catch (e) { console.log(e); throw e; } 
	},
  async downloadPaymentDocument(context, {fileId}) {
    try {
      let response = await api.get('/teams/' + context.rootState.teamId + '/payment-documents/' + fileId);
      return response;
    } catch (e) { console.log(e); throw e; }
  },
	async paymentDocumentRequest(context, payload) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId + '/payment-documents/request', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
}

// mutations
const mutations = {
	fetchPaymentDocuments(state, data) {
		state.index = data;
	},
}

export default {
	state,
	actions,
	mutations
}
